<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 历史订阅关系
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="seefrom.deviceName"></el-input>
              </el-form-item>
              <el-form-item label="设备编码">
                <el-input placeholder="请输入设备编码" v-model="seefrom.deviceMark"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align, width}) in config" :key="prop.toString()" :width="width"></el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage"></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ifSuccess: false,
      addDisplayForm: false,
      tabName: 'jsgl',
      loading: true,
      form_jsgl: {},
      showTable: true,
      //搜索表单
      seefrom: {
        deviceName: '',
        deviceMark: '',
        companyId: localStorage.getItem('companyId')
      },
      items: [],
      tableData: [],
      nTotal: 0,
      currentPage: 0
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'deviceName',
          label: '设备名称'
        },
        {
          prop: 'deviceMark',
          label: '设备编码'
        },
        {
          prop: 'deviceType',
          label: '设备类型'
        },
        {
          prop: 'subscribeIp',
          label: '订阅ip'
        },
        {
          prop: 'sendUrl',
          label: '实时推送地址'
        },
        {
          prop: 'subscribeTimes',
          label: '订阅时间',
          width: 160
        },
        {
          prop: 'firstSendTime',
          label: '首次发送时间',
          width: 160
        },
        {
          prop: 'latestSendTime',
          label: '最近发送时间',
          width: 160
        },
        {
          prop: 'sendFailureCount',
          label: '发送失败数量',
          width: 120,
          align: 'center'
        },
        {
          prop: 'sendSuccessCount',
          label: '发送成功数量',
          width: 120,
          align: 'center'
        }
      ]
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable')
  },
  methods: {
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    //重置
    reset() {
      this.seefrom.deviceName = ''
      this.seefrom.deviceMark = ''
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    getTableData() {
      this.$axiosget('manager/subscribeRelation/page/history', {
        params: {
          pageSize: 10,
          pageNum: this.currentPage,
          ...this.seefrom
        }
      }).then((res) => {
        if (res.data.data.list != null) {
          this.tableData = res.data.data.list.map((item) => {
            return {
              ...item,
              subscribeTimes: item.subscribeTime
                ? item.subscribeTime.replace(
                    /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/g,
                    '$1-$2-$3 $4:$5:$6'
                  )
                : ''
            }
          })
        } else {
          this.tableData = []
        }
        this.nTotal = res.data.data.total
      })
    }
  },
  mounted() {
    this.getTableData()
  }
}
</script>

<style lang="less" scoped>
.content {
  .w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    // z-index: 99;
  }
  .el-input__inner:focus {
    border: 1px solid #3587c7;
  }
  .el-table__body tr.current-row > td {
    background-color: #234366;
  }
  .el-table tr {
    background-color: #2d374d;
  }
  .el-table th {
    background-color: #2d374d;
  }
  .el-table td {
    background-color: #2d374d;
  }

  .el-table td {
    background-color: #2d374d;
  }
  .cell {
    color: #f2f8fe;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/deviceData/historySubscribe.vue